import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, {
    modelValue: _ctx.inputString,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputString) = $event)),
    type: "textarea",
    onChange: _ctx.processInput,
    autosize: { minRows: 2, maxRows: 20 },
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled
  }, null, 8 /* PROPS */, ["modelValue", "onChange", "placeholder", "disabled"]))
}